// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RequirePermission } from "@/components/shared/require-permission";
import { UsersList } from "@/features/iam/users-list";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/iam/users/")({
  validateSearch: z.object({ f: z.string().optional() }),
  component: () => (
    <RequirePermission permission={PAGE_PERMISSIONS.iamUsers}>
      <UsersList />
    </RequirePermission>
  ),
});
